// @flow
import type { Sort } from '../../sharedTypes';

export const SORT = {
  SET_SELECTED_SORT: 'sort/set_selected_sort',
  SET_PRODUCT_REC_AB_KEY: 'sort/set_product_rec_ab_key',
};

export type SetSelectedSortAction = {
  type: typeof SORT.SET_SELECTED_SORT,
  sort: Sort,
};

export type SetProductRecAbKeyAction = {
  type: typeof SORT.SET_PRODUCT_REC_AB_KEY,
  productRecAbKey: String,
};

// This action updates selectedSort in state, which will lead to a getProducts call in the App component
export function setSelectedSort(sort: Sort): SetSelectedSortAction {
  return {
    type: SORT.SET_SELECTED_SORT,
    sort,
  };
}

export function setProductRecAbKey(
  productRecAbKey: string
): SetProductRecAbKeyAction {
  return {
    type: SORT.SET_PRODUCT_REC_AB_KEY,
    productRecAbKey,
  };
}
